// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__fQpf4","color":"Avatar_color__1-Lnv"};